import dayjs from "@/bundles/dayjs";

export default {
    formatDate(value, format = "YYYY-MM-DD") {
        if (!value) {
            return "";
        }
        return dayjs(value).format(format);
    },
    timeAgo(value) {
        if (!value) {
            return "";
        }
        return dayjs(value).fromNow();
    }
}
